import React, { useRef } from 'react';
import { ErrorFlagRenderer } from '@atlassian/jira-error-boundary-flag-renderer/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	uifBacklogResource,
	uifBacklogResourceOld,
} from '@atlassian/jira-router-resources-uif-backlog/src/index.tsx';
import type { JiraPlanDataRestResponse } from '@atlassian/jira-software-backlog-uif-types/src/index.tsx';
import responseToSla from '@atlassian/jira-software-sla-tracker/src/services/response-to-sla/index.tsx';
import type { UIFBacklogCachedDataResult } from '@atlassian/jira-software-uif-early-script/src/index.tsx';
import { useResource, type RouteResourceError } from '@atlassian/react-resource-router';
import {
	EXPERIENCE_TRACKER_LOCATION_BACKLOG,
	EXPERIENCE_TRACKER_LOCATION_CMP_BACKLOG,
} from '../../common/constants/analytics.tsx';

type BacklogSlaTrackerProps = {
	error: RouteResourceError | null;
	location?: string | null;
};

export const BacklogSlaTracker = ({ error, location }: BacklogSlaTrackerProps) => {
	if (error) {
		return (
			<>
				{responseToSla(error, location ?? EXPERIENCE_TRACKER_LOCATION_BACKLOG)}
				{/* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */}
				<ErrorFlagRenderer id={location ?? 'next-gen-backlog'} error={error as Error} />
			</>
		);
	}
	// return null when no errors
	return null;
};

export const CmpBacklogSlaTracker = () => {
	const backlogData = useResource<JiraPlanDataRestResponse | UIFBacklogCachedDataResult | null>(
		fg('indexeddb_cache_for_backlog') ? uifBacklogResource : uifBacklogResourceOld,
	);

	const hasFired = useRef(false);
	if (
		hasFired.current ||
		!backlogData ||
		!backlogData.error ||
		backlogData.data ||
		backlogData.loading
	) {
		return null;
	}

	hasFired.current = true;
	return (
		<BacklogSlaTracker
			error={backlogData?.error}
			location={EXPERIENCE_TRACKER_LOCATION_CMP_BACKLOG}
		/>
	);
};
